import * as actionTypes from './actionTypes';

interface StateProps {
  notifications: [],
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reducer(state:StateProps, action:{ payload: any, type: string }) {
  switch (action.type) {
    case actionTypes.SET_ADMIN_STATE:
      return {
        ...state,
        adminState: action.payload,
      };

    case actionTypes.SET_SITES:
      return {
        ...state,
        organisations: action.payload,
      };

    case actionTypes.SET_USER:
      return {
        ...state,
        user: action.payload,
      };
    
    case actionTypes.SET_USERS:
      return {
        ...state,
        users: action.payload,
      };

    default:
      return state;
  }
}

export default reducer;
